import styled from 'styled-components';
import { COLORS, Color, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

interface StyleProps {
  iconElevated?: boolean;
}

export const Container = styled.div<{ bgColor?: Color }>`
  padding: ${SIZING.unit(2)};
  width: 200px;
  background-color: ${({ bgColor }) => bgColor || COLORS.grey80};
  position: relative;
  @media ${device.tablet} {
    width: 250px;
  }
  @media ${device.laptop} {
    width: 300px;
  }
`;

export const IconWrap = styled.button`
  vertical-align: middle;
  background: transparent;
  margin-left: ${SIZING.unit(1)};
  margin-right: ${SIZING.unit(1.25)};
  padding: 0;
  /* padding: 0 ${SIZING.unit(1.25)} 0 0; */
  height: 20px;
  width: 20px;
  border: none;
  cursor: pointer;
  margin-bottom: ${({ iconElevated }: StyleProps) => (iconElevated ? SIZING.unit(2.5) : 0)};
  &:focus {
    outline: 2px solid ${COLORS.black};
    outline-offset: 2px;
    /* border-radius: 50%; */
  }
  :focus:not(:focus-visible) {
    outline: none;
    outline-offset: 0;
  }
`;

export const Copy = styled.p`
  font-family: 'Audi Type';
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.grey5};
  @media ${device.tablet} {
    font-size: 13px;
    line-height: 21px;
  }
`;

export const Title = styled(Copy)`
  @media ${device.tablet} {
    font-size: 16px;
    line-height: 28px;
  }
`;
